// extracted by mini-css-extract-plugin
module.exports = {"reminder":"ReminderManagerModal_reminder__3jeJJ","modal":"ReminderManagerModal_modal__3LBpC","button":"ReminderManagerModal_button__X91LK"};